import { useState } from 'react'

import { Textarea } from '@factorialco/factorial-one-react/dist/experimental'
import {
  LevelExpectationFragment,
  UpsertJobRoleExpectationDocument,
} from 'generated/resources/graphql'
import { useDebounceCallback } from 'usehooks-ts'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  expectation?: LevelExpectationFragment
  competencyId: string
  levelId: string
}

export const Expectation = ({ expectation, competencyId, levelId }: Props) => {
  const [upsertExpecation] = useMutation(UpsertJobRoleExpectationDocument, {
    extractorFn: (data) => data.jobCatalogMutations.upsertJobcatalogExpectation,
  })

  const debouncedUpsertExpectation = async (newDescription: string) => {
    const result = await upsertExpecation({
      variables: {
        competencyId,
        levelId,
        description: newDescription,
      },
    })

    const handled = handleResult(result, () => {})

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('job_catalog.career_path.competencies_table.expectation_updated'),
      })
    }
  }

  return (
    <DebouncedTextarea
      defaultValue={expectation?.description || ''}
      onChange={(newValue) => {
        debouncedUpsertExpectation(newValue)
      }}
    />
  )
}

const DebouncedTextarea = ({
  defaultValue,
  onChange,
}: {
  defaultValue: string
  onChange: (newValue: string) => void
}) => {
  const [value, setValue] = useState<string>(defaultValue)

  const debounced = useDebounceCallback(onChange, 500)

  return (
    <Textarea
      value={value}
      cols={100}
      rows={100}
      onChange={(event) => {
        setValue(event.target.value)
        debounced(event.target.value)
      }}
      // TODO: This should be in factorial-one
      // onBlur={(event) => onChange(event.target.value)}
    />
  )
}
